// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/myPortfolios/cards/cards.css
// module id = 1514
// module chunks = 0